import { render, staticRenderFns } from "./EditGame.vue?vue&type=template&id=3374c1de&scoped=true"
import script from "./EditGame.vue?vue&type=script&lang=js"
export * from "./EditGame.vue?vue&type=script&lang=js"
import style0 from "./EditGame.vue?vue&type=style&index=0&id=3374c1de&prod&scoped=true&lang=css"
import style1 from "./EditGame.vue?vue&type=style&index=1&id=3374c1de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3374c1de",
  null
  
)

export default component.exports